/* WakeAim · Zona de compra
 * Mejora progresiva: sin JS el formulario envía a /cart/add normalmente.
 */
(() => {
  if (customElements.get('wa-buy-box')) return;

  const formatMoney = (cents, format = window.waMoneyFormat || '{{amount_with_comma_separator}} €') => {
    const value = Number(cents) || 0;
    const fmt = (n, decimals, thousands = '.', decimal = ',') => {
      const fixed = (n / 100).toFixed(decimals);
      const [int, dec] = fixed.split('.');
      const withSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return dec ? withSep + decimal + dec : withSep;
    };
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return fmt(value, 2);
    let out;
    switch (match[1]) {
      case 'amount': out = fmt(value, 2, ',', '.'); break;
      case 'amount_no_decimals': out = fmt(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fmt(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fmt(value, 2, "'", '.'); break;
      case 'amount_with_space_separator': out = fmt(value, 2, ' ', ','); break;
      default: out = fmt(value, 2, '.', ',');
    }
    return format.replace(match[0], out).replace(/<[^>]*>/g, '');
  };

  class WaBuyBox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form.wa-form');
      if (!this.form) return;
      try {
        this.variants = JSON.parse(this.querySelector('[data-wa-variants]').textContent);
      } catch (e) {
        this.variants = [];
      }
      this.fsThreshold = parseInt(this.dataset.fsThreshold, 10) || 0;
      this.submitBtn = this.querySelector('[data-wa-submit]');
      this.errorBox = this.querySelector('[data-wa-error]');
      this.status = this.querySelector('[data-wa-status]');

      this.revealed = this.quantity;
      this.form.addEventListener('change', (e) => {
        if (e.target.matches('[data-wa-pack]')) this.update(null);
        else if (e.target.matches('[data-wa-variant]')) this.update(e.target);
      });
      this.form.addEventListener('submit', (e) => this.onSubmit(e));

      this.initGallery();
      this.initSticky();
      this.update(null);
    }

    findVariant(id) {
      return this.variants.find((v) => v.id === Number(id)) || null;
    }

    get packInput() {
      return this.form.querySelector('[data-wa-pack]:checked') || this.form.querySelector('[name="quantity"]');
    }

    get quantity() {
      const input = this.packInput;
      return Math.max(1, parseInt(input ? input.value : 1, 10) || 1);
    }

    get discount() {
      const input = this.packInput;
      return Math.max(0, parseInt(input && input.dataset.discount, 10) || 0);
    }

    rows() {
      return Array.from(this.form.querySelectorAll('[data-wa-unit-row]'));
    }

    /* Variante elegida en cada unidad visible del pack */
    get units() {
      const rows = this.rows();
      if (!rows.length) {
        const hidden = this.form.querySelector('[name="id"]');
        const v = hidden ? this.findVariant(hidden.value) : null;
        return Array.from({ length: this.quantity }, () => v);
      }
      return rows.slice(0, this.quantity).map((row) => {
        const input = row.querySelector('[data-wa-variant]:checked');
        return input ? this.findVariant(input.value) : null;
      });
    }

    syncRows() {
      const qty = this.quantity;
      const rows = this.rows();
      if (!rows.length) return;
      // Las unidades nuevas empiezan con el color de la unidad 1
      if (qty > this.revealed) {
        const first = rows[0].querySelector('[data-wa-variant]:checked');
        for (let i = this.revealed; i < qty && i < rows.length; i++) {
          const same = first && rows[i].querySelector(`[data-wa-variant][value="${first.value}"]`);
          if (same && !same.disabled) same.checked = true;
        }
        this.revealed = qty;
      }
      rows.forEach((row, i) => {
        const visible = i < qty;
        row.hidden = !visible;
        row.disabled = !visible;
        row.querySelector('[data-wa-unit-prefix]')?.classList.toggle('visually-hidden', qty === 1);
        const checked = row.querySelector('[data-wa-variant]:checked');
        const name = row.querySelector('[data-wa-unit-name]');
        const v = checked && this.findVariant(checked.value);
        if (name && v) name.textContent = v.title;
      });
      const title = this.querySelector('[data-wa-colors-title]');
      if (title) {
        title.textContent = qty === 1 ? this.dataset.colorLabel || 'Color' : this.dataset.unitsLabel || 'Elige el color de cada unidad';
      }
    }

    update(changedInput) {
      this.hideError();
      this.syncRows();
      const qty = this.quantity;
      const units = this.units;
      const complete = units.length === qty && units.every(Boolean);
      if (!complete) {
        this.setButton(false, 'Elige un color');
        return;
      }
      const available = units.every((u) => u.available);
      const regular = units.reduce((sum, u) => sum + u.price, 0);
      const discount = Math.min(this.discount, regular);
      const total = regular - discount;
      const totalText = formatMoney(total);

      this.querySelectorAll('[data-wa-total]').forEach((el) => (el.textContent = totalText));

      // Tachado: descuento del pack o, en 1 unidad, el precio de comparación real de Shopify
      let shownCompare = regular;
      let shownSave = discount;
      if (qty === 1 && units[0].compare > units[0].price) {
        shownCompare = units[0].compare;
        shownSave = units[0].compare - units[0].price;
      }
      const compare = this.querySelector('[data-wa-compare]');
      if (compare) {
        compare.hidden = shownSave === 0;
        compare.querySelector('[data-wa-compare-value]').textContent = formatMoney(shownCompare);
      }
      const save = this.querySelector('[data-wa-save]');
      if (save) {
        save.hidden = shownSave === 0;
        save.querySelector('[data-wa-save-value]').textContent = formatMoney(shownSave);
      }

      // Tarjetas de pack: precio de referencia = color de la unidad 1
      const base = units[0].price;
      this.form.querySelectorAll('[data-wa-pack]').forEach((input) => {
        const q = parseInt(input.value, 10);
        const d = Math.min(parseInt(input.dataset.discount, 10) || 0, base * q);
        const card = input.closest('.wa-pack');
        const t = card.querySelector('[data-wa-pack-total]');
        if (t) t.textContent = formatMoney(base * q - d);
        const c = card.querySelector('[data-wa-pack-compare]');
        if (c) c.textContent = formatMoney(base * q);
        const cs = card.querySelector('[data-wa-pack-compare-single]');
        if (cs) {
          cs.hidden = !(units[0].compare > units[0].price);
          cs.textContent = formatMoney(units[0].compare);
        }
        const s = card.querySelector('[data-wa-pack-save]');
        if (s) s.textContent = `Ahorras ${formatMoney(d)}`;
        const u = card.querySelector('[data-wa-pack-unit]');
        if (u) u.textContent = `${formatMoney(base)}/ud.`;
        const pu = card.querySelector('[data-wa-pack-perunit]');
        if (pu) pu.textContent = `${formatMoney(Math.floor((base * q - d) / q))}/ud.`;
        const fs = card.querySelector('[data-wa-pack-fs]');
        if (fs) fs.hidden = !(this.fsThreshold > 0 && base * q - d >= this.fsThreshold);
      });

      const price = this.querySelector('[data-wa-submit-price]');
      if (price) price.textContent = totalText;
      this.setButton(available, available ? null : 'Color agotado');

      // Aviso de stock bajo: solo con el stock real de Shopify
      const low = this.querySelector('[data-wa-lowstock]');
      if (low) {
        const limit = parseInt(low.dataset.limit, 10) || 0;
        low.hidden = !(limit > 0 && units.some((u) => typeof u.stock === 'number' && u.stock > 0 && u.stock <= limit));
      }

      const summary = this.summaryText(units);
      if (this.sticky) {
        const sel = this.sticky.querySelector('[data-wa-sticky-sel]');
        if (sel) sel.textContent = summary;
        const sp = this.sticky.querySelector('[data-wa-sticky-price]');
        if (sp) sp.textContent = totalText;
        const img = this.sticky.querySelector('.wa-sticky__img');
        if (img && units[0].image) {
          img.src = units[0].image;
          img.removeAttribute('srcset');
        }
        const stickyAdd = this.sticky.querySelector('[data-wa-sticky-add]');
        if (stickyAdd) stickyAdd.disabled = !available;
      }

      if (changedInput) {
        const v = this.findVariant(changedInput.value);
        if (v && v.media) this.goToMedia(v.media);
        if (this.dataset.updateUrl === 'true' && v && changedInput.name === 'id') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    summaryText(units) {
      const counts = new Map();
      units.forEach((u) => counts.set(u.title, (counts.get(u.title) || 0) + 1));
      const parts = Array.from(counts, ([title, n]) => (n > 1 ? `${n}× ${title}` : title));
      const label = units.length === 1 ? '1 ud.' : `${units.length} uds.`;
      return `${label} · ${parts.join(' + ')}`;
    }

    setButton(enabled, text) {
      if (!this.submitBtn) return;
      this.submitBtn.disabled = !enabled;
      const label = this.submitBtn.querySelector('[data-wa-submit-label]');
      label.textContent = text || this.submitBtn.dataset.label || 'Añadir al carrito';
      this.submitBtn.querySelectorAll('[data-wa-submit-price], .wa-btn__sep').forEach((el) => (el.hidden = !enabled));
    }

    showError(message) {
      if (!this.errorBox) return;
      this.errorBox.querySelector('[data-wa-error-text]').textContent = message;
      this.errorBox.hidden = false;
    }

    hideError() {
      if (this.errorBox) this.errorBox.hidden = true;
    }

    async onSubmit(event) {
      event.preventDefault();
      const units = this.units;
      if (!units.length || !units.every(Boolean)) return this.showError('Elige un color para cada unidad.');
      const soldOut = units.find((u) => !u.available);
      if (soldOut) return this.showError(`El color ${soldOut.title} está agotado. Elige otro.`);
      if (this.submitBtn.classList.contains('is-loading')) return;

      this.hideError();
      this.submitBtn.classList.add('is-loading');
      this.submitBtn.setAttribute('aria-busy', 'true');
      if (this.status) this.status.textContent = 'Añadiendo al carrito…';

      // Agrupa las unidades por variante: 2 negros + 1 blanco = 2 líneas
      const grouped = new Map();
      units.forEach((u) => grouped.set(u.id, (grouped.get(u.id) || 0) + 1));

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = new FormData();
      let i = 0;
      grouped.forEach((quantity, id) => {
        body.append(`items[${i}][id]`, id);
        body.append(`items[${i}][quantity]`, quantity);
        i++;
      });
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map((s) => s.id));
        body.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }

      const firstId = units[0].id;
      try {
        const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}`, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          const msg = data.description || data.message || 'No se ha podido añadir al carrito. Inténtalo de nuevo.';
          this.showError(msg);
          if (this.status) this.status.textContent = msg;
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'wa-buy-box', productVariantId: firstId, errors: msg });
          }
          return;
        }
        if (this.status) this.status.textContent = 'Añadido al carrito.';
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wa-buy-box', productVariantId: firstId, cartData: data });
        }
        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (e) {
        this.showError('Hay un problema de conexión. Revisa tu conexión e inténtalo de nuevo.');
      } finally {
        this.submitBtn.classList.remove('is-loading');
        this.submitBtn.removeAttribute('aria-busy');
      }
    }

    /* Galería */
    initGallery() {
      this.track = this.querySelector('[data-wa-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.thumbs = Array.from(this.querySelectorAll('[data-wa-thumb]'));
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(parseInt(t.dataset.waThumb, 10))));
      this.querySelector('[data-wa-prev]')?.addEventListener('click', () => this.goTo(this.index - 1));
      this.querySelector('[data-wa-next]')?.addEventListener('click', () => this.goTo(this.index + 1));
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index - 1); }
      });
      this.index = 0;
      let ticking = false;
      this.track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i !== this.index) this.setActive(i);
          ticking = false;
        });
      }, { passive: true });
    }

    goTo(i) {
      if (!this.slides || !this.slides.length) return;
      const n = this.slides.length;
      const idx = (i + n) % n;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.slides[idx].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      this.setActive(idx);
    }

    goToMedia(mediaId) {
      if (!this.slides) return;
      const idx = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (idx >= 0) this.goTo(idx);
    }

    setActive(i) {
      this.index = i;
      this.slides.forEach((s, n) => {
        const video = s.querySelector('video');
        if (n !== i && video && !video.paused) video.pause();
      });
      this.thumbs.forEach((t, n) => {
        t.classList.toggle('is-active', n === i);
        if (n === i) {
          t.setAttribute('aria-current', 'true');
          const list = t.closest('.wa-gallery__thumbs');
          if (list) {
            const left = t.offsetLeft - list.clientWidth / 2 + t.clientWidth / 2;
            list.scrollTo({ left, behavior: 'auto' });
          }
        } else t.removeAttribute('aria-current');
      });
    }

    /* Barra fija móvil */
    initSticky() {
      this.sticky = this.querySelector('[data-wa-sticky]');
      if (!this.sticky || !this.submitBtn) return;
      // Se mueve al final del body para que ningún contenedor la recorte.
      document.body.appendChild(this.sticky);
      this.sticky.querySelector('[data-wa-sticky-add]')?.addEventListener('click', () => {
        if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit();
        else this.form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      this.sticky.querySelector('[data-wa-sticky-change]')?.addEventListener('click', () => {
        const target = this.querySelector('[data-wa-colors]') || this.querySelector('[data-wa-packs]') || this.form;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        const focusable = target.querySelector('input:checked') || target.querySelector('input');
        setTimeout(() => focusable && focusable.focus({ preventScroll: true }), reduce ? 0 : 450);
      });

      this.btnVisible = true;
      this.mq = window.matchMedia('(max-width: 989px)');
      this.observers = [];

      const io = new IntersectionObserver(([entry]) => {
        this.btnVisible = entry.isIntersecting;
        this.refreshSticky();
      });
      io.observe(this.submitBtn);
      this.observers.push(io);

      const footer = document.querySelector('.footer, footer');
      if (footer) {
        const fo = new IntersectionObserver(([entry]) => {
          this.footerVisible = entry.isIntersecting;
          this.refreshSticky();
        });
        fo.observe(footer);
        this.observers.push(fo);
      }

      const mo = new MutationObserver(() => this.refreshSticky());
      mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.observers.push(mo);
      this.mq.addEventListener?.('change', () => this.refreshSticky());
    }

    refreshSticky() {
      const cls = document.body.classList;
      const overlayOpen =
        cls.contains('overflow-hidden') || cls.contains('overflow-hidden-mobile') || cls.contains('overflow-hidden-tablet');
      // Visible siempre que el botón principal no esté en pantalla (antes o después de él)
      const show = this.mq.matches && !this.btnVisible && !overlayOpen && !this.footerVisible;
      if (this.sticky.classList.contains('is-visible') === show) return;
      this.sticky.classList.toggle('is-visible', show);
      this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) this.sticky.removeAttribute('inert');
      else this.sticky.setAttribute('inert', '');
      document.body.classList.toggle('wa-has-sticky', show);
    }

    disconnectedCallback() {
      // En el editor de temas la sección se vuelve a renderizar: limpiamos la barra movida al body.
      if (this.sticky && this.sticky.parentNode === document.body) this.sticky.remove();
      document.body.classList.remove('wa-has-sticky');
      this.observers?.forEach((o) => o.disconnect());
    }
  }

  customElements.define('wa-buy-box', WaBuyBox);
})();
